import React from 'react';
import embryoLogo from "../assets/embryo-removebg.png";

const Footer = () => {
  return (
    <div className='footer-background' style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <div className='footer-container' style={{ display: "flex", alignItems: "center", textAlign: "center" }}>
          <div className='footer-text' style={{ fontSize: "12px" }}>
            All rights reserved. Powered by The  
          </div>      
          <img 
            src={embryoLogo} 
            alt="Embryo Logo" 
            style={{ width: "90px", height: "auto", marginLeft: "10px" }} 
          />
        </div>
    </div>
  );
}

export default Footer;
